module.exports = __webpack_public_path__ + "media/customizations/wonderlandbyrunway/logo-bc63a56fd47ac5d5a7fc9f6ed1847d30.png";